import { ChangeDetectionStrategy, Component, computed, Input, signal, WritableSignal } from "@angular/core";
import { Steps } from "../getting-started.contants";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-status-panel",
  templateUrl: "./status-panel.component.html",
  styleUrl: "./status-panel.component.scss",
  imports: [CommonModule, MatButtonModule, RouterModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusPanelComponent {

  @Input() set currentStepIndex(val: number) {
    this.currentStep.set(val);
  }

  @Input() set completedStepValue(val: number) {
    this.completedSteps.set(val);
  }

  readonly steps = Steps;
  currentStep: WritableSignal<number> = signal<number>(1);
  completedSteps: WritableSignal<number> = signal<number>(0);
  totalSteps = computed(() => this.steps.length);
  progressValue = computed(() => (this.completedSteps() / this.totalSteps()) * 100);

  constructor(private router: Router) { }

  navigateToOnboarding() {
    const currentUrl = this.router.url;
    const isInsideGettingStarted = currentUrl.startsWith('/getting-started');
    const stepIndex = this.currentStep();
    const step = this.steps[stepIndex - 1];
    if (!step?.route) {
      console.warn('No route found for current step:', stepIndex);
      return;
    }
    if (isInsideGettingStarted) {
      this.router.navigate([step.route]);
    } else {
      this.router.navigate(['/getting-started']);
    }
  }

}
